import { PropsWithoutRef, useState } from "react";
import {
  Drawer,
  Toolbar,
  List,
  ListItemIcon,
  ListItemText,
  ListItemButton,
  Box,
  IconButton,
  Tooltip,
  Collapse,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import InventoryIcon from "@mui/icons-material/Inventory";
import CategoryIcon from "@mui/icons-material/Category";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { SIDEBAR_WIDTH } from "../constants";

interface Props {
  mobileOpen: boolean;
  handleSidebarToggle: () => void;
}

export default function Sidebar({
  mobileOpen,
  handleSidebarToggle,
}: PropsWithoutRef<Props>) {
  // ✅ Hooks must be used inside the component
  const [openProductMenu, setOpenProductMenu] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleProductClick = () => {
    setOpenProductMenu(!openProductMenu);
  };

  const drawer = (
    <>
      <Toolbar className="sidebar-logo" sx={{ position: "relative" }}>
        <a
          href="/dashboard"
          onClick={() => {
              navigate("/dashboard");
          }}
          className="logo_link web"
        >
          <figure>
            <img src="/static/images/logo.png" alt="Bouteek Logo" />
          </figure>
        </a>

        <a
          href="/dashboard"
          onClick={() => {
            navigate("/dashboard");
          }}
          className="logo_link mobile"
        >
          <figure>
            <img src="/static/images/logo_small.png" alt="Bouteek Logo" />
          </figure>
        </a>

        <IconButton
          sx={{
            display: "none",
            position: "absolute",
            top: "10px",
            right: "10px",
          }}
          onClick={handleSidebarToggle}
        >
          <MenuIcon />
        </IconButton>
      </Toolbar>

      <List sx={{ flexGrow: 1 }} className="sidebr-lst">
        {/* Dashboard */}
        <Tooltip title="Dashboard" placement="right">
          <ListItemButton
            id="step-dashboard"
            className="lst-itm"
            selected={location.pathname === "/dashboard"}
            onClick={() => navigate("/dashboard")}
          >
            <ListItemIcon>
              <img src="/static/images/dashboard_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Dashboard" />
          </ListItemButton>
        </Tooltip>
        <Tooltip title="Portfolio management" placement="right">
          <ListItemButton
            id="step-portfolio"
            className="lst-itm"
            selected={location.pathname.startsWith("/portfolio")}
            onClick={() => navigate("/portfolio")}
          >
            <ListItemIcon>
              <img src="/static/images/portfolio.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Portfolio management" />
          </ListItemButton>
        </Tooltip>
        <Tooltip title="Service Listings Management" placement="right">
          <ListItemButton
            id="step-services"
            className="lst-itm"
            selected={location.pathname.startsWith("/service-listing")}
            onClick={() => navigate("/service-listing")}
          >
            <ListItemIcon>
              <img src="/static/images/service.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Service Listings " />
          </ListItemButton>
        </Tooltip>

        <Tooltip title="My Bookings" placement="right">
          <ListItemButton
            id="step-bookings"
            className="lst-itm"
            selected={location.pathname.startsWith("/order-management")}
            onClick={() => navigate("/order-management")}
          >
            <ListItemIcon>
              <img src="/static/images/booking_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="My Bookings" />
          </ListItemButton>
        </Tooltip>
        <Tooltip title="Chat" placement="right">
          <ListItemButton
            id="step-chat"
            className="lst-itm"
            selected={location.pathname === "/chat"}
            onClick={() => navigate("/chat")}
          >
            <ListItemIcon>
              <img src="/static/images/chat.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Chat" />
          </ListItemButton>
        </Tooltip>

        <Tooltip title="My Earnings" placement="right">
          <ListItemButton
            id="step-earnings"
            className="lst-itm"
            selected={location.pathname === "/earnings"}
            onClick={() => navigate("/earnings")}
          >
            <ListItemIcon>
              <img src="/static/images/earning.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="My Earnings" />
          </ListItemButton>
        </Tooltip>

        <Tooltip title="Discount and Coupons" placement="right">
          <ListItemButton
            id="step-discount"
            className="lst-itm"
            selected={location.pathname.startsWith("/discount-coupon")}
            onClick={() => navigate("/discount-coupon")}
          >
            <ListItemIcon>
              <img src="/static/images/discount.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Discount and Coupons" />
          </ListItemButton>
        </Tooltip>
        <Tooltip title="Rating & Reviews" placement="right">
          <ListItemButton
            id="step-ratings"
            className="lst-itm"
            selected={location.pathname.startsWith("/ratings")}
            onClick={() => navigate("/ratings")}
          >
            <ListItemIcon>
              <img src="/static/images/rating_icon.svg" alt="Icon" />
            </ListItemIcon>
            <ListItemText className="lstitm-txt" primary="Rating & Reviews" />
          </ListItemButton>
        </Tooltip>







        <ListItemButton id="step-support" className="lst-itm" onClick={handleProductClick}>
          <ListItemIcon>
            <img src="/static/images/support_icon.svg" alt="Icon" />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Support Management" />
          {openProductMenu ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>

        <Collapse in={openProductMenu} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItemButton
              sx={{ pl: 4 }}
              selected={location.pathname.startsWith("/admin-support")}
              onClick={() => navigate("/admin-support")}
            >
              <ListItemText primary="Admin Support" />
            </ListItemButton>

            {/* <ListItemButton
              sx={{ pl: 4 }}
              selected={location.pathname === "/customer-support"}
              onClick={() => navigate("/customer-support")}
            >
              <ListItemText primary="Vendor Support" />
            </ListItemButton> */}
          </List>
        </Collapse>

      </List>
    </>
  );

  return (
    <Box
      component="nav"
      sx={{
        width: mobileOpen ? SIDEBAR_WIDTH : 0,
        transition: "width 0.3s",
        overflowX: "hidden",
      }}
      className={mobileOpen ? "sidebar-main-div active" : "sidebar-main-div"}
    >
      <Drawer
        className="sidebar_drawer"
        variant="persistent"
        sx={{
          "& .MuiDrawer-paper": {
            width: SIDEBAR_WIDTH,
            boxSizing: "border-box",
          },
        }}
        open
      >
        {drawer}
      </Drawer>
    </Box>
  );
}
